import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['label', 'picker', 'calendar', 'banner', 'field'];
  static classes = ['warning', 'changed'];

  connect() {
    $(this.calendarTarget).datepicker();
    $(this.calendarTarget).datepicker('setDate', new Date());
    this.boundCloseOnOutside = this.#closeOnOutside.bind(this);
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseOnOutside);
  }

  toggle(event) {
    event.preventDefault();

    if (this.pickerTarget.classList.contains('hidden')) {
      this.pickerTarget.classList.remove('hidden');
      setTimeout(() => document.addEventListener('click', this.boundCloseOnOutside), 0);
    } else {
      this.#close();
    }
  }

  save(event) {
    event.preventDefault();

    const date = $(this.calendarTarget).datepicker('getDate');
    if (!date) {
      return;
    }

    this.fieldTarget.value = this.#toISO(date);
    this.#applyChanged(this.#formatLabel(date));
    this.#close();
  }

  #applyChanged(label) {
    this.labelTarget.innerHTML = `Issue date is changed to <strong>${label}</strong>`;
    this.bannerTarget.classList.remove(...this.warningClasses);
    this.bannerTarget.classList.add(...this.changedClasses);
  }

  #close() {
    this.pickerTarget.classList.add('hidden');
    document.removeEventListener('click', this.boundCloseOnOutside);
  }

  #closeOnOutside(event) {
    const target = event.target;
    if (
      this.element.contains(target) ||
      target.closest('.ui-datepicker-prev') ||
      target.closest('.ui-datepicker-next') ||
      target.closest('.ui-datepicker')
    ) {
      return;
    }

    this.#close();
  }

  #formatLabel(date) {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  #toISO(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
